import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { PageBreakAfterDiv, PrintOnlyDiv, TopRightLogo } from "commons";

export class CoverSheet extends PureComponent {
    render() {
        const clientName = this.props.clientDetails
            ? (this.props.clientDetails.forename || "") + " " + this.props.clientDetails.surname
            : "";
        const clientId = this.props.clientDetails ? this.props.clientDetails.clientId : "";
        const adviserName = this.props.adviserDetails
            ? (this.props.adviserDetails.forename || "") + " " + this.props.adviserDetails.surname
            : "";
        const adviserOutletId = this.props.adviserDetails
            ? this.props.adviserDetails.adviserOutletId
            : "";
        const account = this.props.accountDetails
            ? this.props.accountDetails.accountNumber +
              " (" +
              this.props.accountDetails.wrapperType +
              ")"
            : "";
        return (
            <PageBreakAfterDiv>
                <PrintOnlyDiv>
                    <TopRightLogo logo={this.props.logo} />
                    <CoverH1>
                        <p>{clientName.trim()}</p>
                        <p>Transactions</p>
                    </CoverH1>
                    <CoverDetails>
                        <p>Client reference: {clientId}</p>
                        <p>Account: {account}</p>
                        <p>
                            Adviser: {adviserName.trim()} - {adviserOutletId}
                        </p>
                        <p>
                            Transactions date range: {this.props.startDate} to {this.props.endDate}
                        </p>
                    </CoverDetails>
                </PrintOnlyDiv>
            </PageBreakAfterDiv>
        );
    }
}

export const CoverH1 = styled.h1`
    color: ${props => props.theme.primary};
    margin-top: 150px;
    font-size: 30px;
    font-weight: bold;
`;

export const CoverDetails = styled.div`
    margin-top: 150px;
    font-size: 20px;
    color: black;
`;

CoverSheet.propTypes = {
    clientDetails: PropTypes.shape({
        clientId: PropTypes.number,
        surname: PropTypes.string,
        forename: PropTypes.string
    }),
    adviserDetails: PropTypes.shape({
        forename: PropTypes.string,
        surname: PropTypes.string,
        adviserOutletId: PropTypes.string
    }),
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    accountDetails: PropTypes.shape({
        accountNumber: PropTypes.string,
        prlkShortName: PropTypes.string,
        annualAdviserFeePercentage: PropTypes.number,
        wrapperType: PropTypes.string
    }),
    logo: PropTypes.string
};
